// Cognito accounts predate e:vc, e:ex and v:co and keep holding them; Keycloak grants them explicitly.
export const COGNITO_IMPLIED_PERMISSIONS = ['e:vc', 'e:ex', 'v:co'] as const;

export const withCognitoImpliedPermissions = (permissions: readonly string[]): string[] => [
  ...new Set([...permissions, ...COGNITO_IMPLIED_PERMISSIONS])
];
